/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const ModalHeader = styled(Modal.Header)`
  display: flex;
  justify-content: center;
  border: none;

  h3 {
    font-size: 20px;
    font-weight: 400;
  }
`;

const ModalBody = styled(Modal.Header)`
  display: block;
  border: none;
  p {
    color: #707070;
    font-size: 15px;
    margin: 3px;
  }

  address {
    margin: 25px;

    h4 {
      font-size: 16px;
    }
    p {
      color: #1271a3;
    }
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
`;

const LinkButton = styled.button`
  color: #414141;
  background: transparent;
  border: none;
  padding: 0;
`;
const EmpresaModal = ({ visible, setVisible, empresa }) => {
  return (
    <>
      <Modal show={visible} dialogClassName="modal-90w" centered>
        <ModalHeader className="text-center">
          <h3>{empresa.nome_fantasia}</h3>
        </ModalHeader>
        <ModalBody>
          {empresa.descricao}

          <address>
            <h4>Endereço</h4>
            <p>
              {empresa.endereco.logradouro} - {empresa.endereco.numero}
            </p>
            <p>
              {empresa.endereco.cidade} - {empresa.endereco.bairro}
            </p>
            <p>
              {empresa.endereco.estado} - {empresa.endereco.pais}
            </p>
          </address>
        </ModalBody>
        <ModalFooter>
          <LinkButton onClick={() => setVisible(false)}>Fechar</LinkButton>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EmpresaModal;
